import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StoreState } from '../types/state';
import { getClientProperties } from '../redux/actions/clients';

const useClientProperties = (id) => {
  const properties = useSelector((state: StoreState) => {
    return state.clients.clientProperties[id];
  });
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!properties) {
      setIsLoading(true);
      dispatch(getClientProperties(id));
    } else {
      setIsLoading(false);
    }
  }, [properties, id, dispatch]);

  return { isLoading, properties };
};
export default useClientProperties;
